function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.705882%,82.352941%,78.039216%)",
      fillOpacity: 1
    },
    d: "M 4.5 0 L 25.5 0 C 27.984375 0 30 2.015625 30 4.5 L 30 25.5 C 30 27.984375 27.984375 30 25.5 30 L 4.5 30 C 2.015625 30 0 27.984375 0 25.5 L 0 4.5 C 0 2.015625 2.015625 0 4.5 0 Z M 4.5 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.054688 21.269531 C 16.347656 21.210938 16.875 21.09375 16.875 20.390625 C 16.875 20.390625 16.816406 18.632812 17.636719 18.398438 C 18.457031 18.164062 19.511719 20.097656 20.625 20.859375 C 21.445312 21.386719 22.089844 21.328125 22.089844 21.328125 L 25.078125 21.269531 C 25.078125 21.269531 26.601562 21.152344 25.898438 19.921875 C 25.839844 19.804688 25.371094 19.042969 23.613281 17.460938 C 21.796875 15.703125 22.089844 15.996094 24.257812 13.007812 C 25.605469 11.191406 26.191406 10.078125 26.015625 9.667969 C 25.78125 9.257812 24.84375 9.316406 24.84375 9.316406 L 21.503906 9.316406 C 21.152344 9.316406 20.976562 9.375 20.800781 9.667969 C 20.800781 9.667969 20.273438 11.132812 19.570312 12.304688 C 18.105469 14.824219 17.519531 14.941406 17.226562 14.765625 C 16.699219 14.472656 16.816406 13.359375 16.816406 12.597656 C 16.816406 9.960938 17.226562 9.023438 16.054688 8.789062 C 15.292969 8.671875 12.597656 8.554688 11.777344 8.964844 C 11.367188 9.199219 11.132812 9.609375 11.308594 9.667969 C 11.484375 9.667969 12.011719 9.726562 12.304688 10.078125 C 12.773438 10.839844 12.832031 14.472656 12.1875 14.824219 C 11.308594 15.46875 9.082031 11.191406 8.554688 9.785156 C 8.4375 9.433594 8.261719 9.375 7.851562 9.257812 L 4.628906 9.257812 C 4.277344 9.257812 3.75 9.316406 3.984375 10.019531 C 5.566406 13.300781 8.847656 21.328125 14.765625 21.269531 Z M 16.054688 21.269531 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkFooter);
export default __webpack_public_path__ + "static/media/vk_footer.63391d6e488d4d7bb780b6485bd02c51.svg";
export { ForwardRef as ReactComponent };